import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress } from "@mui/material";
export const UiCircularProgress = (props) => (_jsx(CircularProgress, Object.assign({}, props)));
//# sourceMappingURL=ui_circular_progress.js.map